import { render, staticRenderFns } from "./ThgBillingSelectionItemPartnerData.vue?vue&type=template&id=9b868ae6&"
import script from "./ThgBillingSelectionItemPartnerData.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionItemPartnerData.vue?vue&type=script&lang=ts&"
import style0 from "./ThgBillingSelectionItemPartnerData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardActions,VForm,VSkeletonLoader,VTextField})
